<template>
 <div>
      <h1 class="display-4">JetDock Wisconsin</h1>
        <hr class="my-4">
      <p class="lead">
        docks here
        </p>
 </div>
</template>
